<div class="assent">
  <h1 mat-dialog-title>{{data.title}}</h1>
  <div mat-dialog-content>
    <p>{{data.content}}</p>
  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onCancel()">{{data.cancel}}</button>
    <button mat-button [mat-dialog-close]="data.animal" cdkFocusInitial>{{data.ok}}</button>
  </div>
</div>